import { useEffect } from "react";
import { useDebouncedCallback } from "use-debounce";
import { Output } from "valibot";

import { ChatDataSchema } from "components/SonicBot/schemas";

import { getPreservedChatDataKey } from "./functions";

function usePreserveChatData(
  instanceName: string,
  token: string,
  chatData: Output<typeof ChatDataSchema>,
  chatId: string,
) {
  const saveChatDataToSessionStorage = useDebouncedCallback(
    () => {
      const preservedChatDataKey = getPreservedChatDataKey(instanceName, token);
      try {
        sessionStorage.setItem(
          preservedChatDataKey,
          JSON.stringify({
            chatData,
            chatId,
          }),
        );
      } catch {
        // Do nothing
      }
    },
    500,
    {
      maxWait: 500,
      leading: true,
    },
  );

  useEffect(() => {
    saveChatDataToSessionStorage();
  }, [saveChatDataToSessionStorage, chatData, chatId]);
}

export default usePreserveChatData;
